// extracted by mini-css-extract-plugin
export default {"reportTabs":"CustomToggle_reportTabs__eWqQa","reportTab":"CustomToggle_reportTab__cSdz5","active":"CustomToggle_active__k8tOK"};